import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Socket } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';
import { Subject, tap } from 'rxjs';
import {
  RingostatCallJournalResponse,
  RingostatAttentionSummary,
  RingostatClickToCallRequest,
  RingostatClickToCallResponse,
  RingostatIncomingCallNotification
} from 'src/typings';

@Injectable({
  providedIn: 'root'
})
export class RingostatCallService {
  readonly attentionChanged$ = new Subject<void>();

  incomingCallGW = this.socket.fromEvent<RingostatIncomingCallNotification>(
    'ringostat_incoming_call'
  );

  callFinishedGW = this.socket.fromEvent<RingostatIncomingCallNotification>(
    'ringostat_call_finished'
  );

  constructor(private readonly socket: Socket, private readonly http: HttpClient) {}

  clickToCall(payload: RingostatClickToCallRequest) {
    return this.http.post<RingostatClickToCallResponse>(
      `${environment.BACKEND}/ringostat/click-to-call`,
      payload
    );
  }

  getCallJournal(params: { days?: number; limit?: number; missedOnly?: boolean } = {}) {
    return this.http.get<RingostatCallJournalResponse>(
      `${environment.BACKEND}/ringostat/call-journal`,
      {
        params: {
          ...params
        } as Record<string, string | number | boolean>
      }
    );
  }

  getAttentionSummary() {
    return this.http.get<RingostatAttentionSummary>(
      `${environment.BACKEND}/ringostat/attention-summary`
    );
  }

  hideCall(callId: string) {
    return this.http.post<{ success: boolean; callId: string }>(
      `${environment.BACKEND}/ringostat/calls/hide`,
      { callId }
    ).pipe(tap(() => this.attentionChanged$.next()));
  }
}
